import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import Context from 'frontools/core/Context';
import Breakpoint from 'frontools/core/Breakpoint';
import ScrollUtils from 'frontools/utils/ScrollUtils';
import { autobind } from 'node_modules/frontools/decorators/Autobind';
import FormValidation from 'frontools/data/FormValidation'
import { FormEventType } from 'frontools/data/FormValidation';
import Request from 'frontools/data/Request';
import { RequestConfig, RequestEvent, RequestMethod } from 'frontools/data/Request';

declare var dataLayer;

export class Form extends AbstractDispatcher {

    private _delayRestart           : number                        = 20;

    private _btnSubscribe           : HTMLElement;
    private _btnSubmit              : HTMLElement;
    private _btnCancel              : HTMLElement;
    private _btnThanks              : HTMLElement;
    private _errorTxt               : HTMLElement;
    private _loading                : HTMLElement;

    private _intro                  : HTMLElement;
    private _form                   : HTMLElement;
    private _thanks                 : HTMLElement;

    private _fV                     : FormValidation;

    constructor() {
        super();

        
        this._btnSubscribe = document.querySelector('[data-js="btnSubscribe"]');
        this._btnSubmit = document.querySelector('[data-js="btnSubmit"]');
        this._btnCancel = document.querySelector('[data-js="btnCancel"]');
        this._btnThanks = document.querySelector('[data-js="btnRestart"]');

        this._loading = document.querySelector('[data-js="loading"]');
        
        this._errorTxt = document.querySelector('.error_message');

        this._intro = document.querySelector('.form_intro') as HTMLElement;
        this._form = document.querySelector('.form') as HTMLElement;
        this._thanks = document.querySelector('.form_thank_you') as HTMLElement;
        
        this._initForm();

        TweenMax.set(this._intro, {left:"200%",alpha: 1});
        TweenMax.set(this._form, {left:"200%",alpha: 1});
        TweenMax.set(this._thanks, {left:"200%",alpha: 1});

        this._btnSubscribe.addEventListener('click', this._hideSubscribe);
        this._btnThanks.addEventListener('click', this._restart);
        this._btnCancel.addEventListener('click', this._restart);

        this._showElement(this._intro, true, false);

    };

    @autobind
    private _hideSubscribe(e) {
        e.preventDefault();
        this._showElement(this._intro, false,true);
        this._showElement(this._form, true, false);
    }

    private _initForm() {
        // clean form on load
        this._form.querySelector('form').reset();

        this._fV = new FormValidation(this._form.querySelector('form') as HTMLFormElement);    
            
        this._fV.addListener(FormEventType.ERROR, function(e) {
            // console.log(e);
            let error = this._form.querySelector('.error');
            this.scrollTo(error);
        }.bind(this));
    
        this._fV.addListener(FormEventType.SEND, function(e) {
            e.submit.preventDefault();
            this._sendForm();
        }.bind(this));

        
    }

    private _sendForm() {
        this._loading.style.display = "flex";
        if((this._form.querySelector('form #optin_familledulait') as HTMLInputElement).checked) {
            dataLayer.push({
                eventCategory: 'infolettre',
                eventAction: 'jeux-evenements',
                eventLabel: 'fdl',
                event: 'genericGAEvent'
            });
        }
        if((this._form.querySelector('form #optin_recettesdici') as HTMLInputElement).checked) {
            dataLayer.push({
                eventCategory: 'infolettre',
                eventAction: 'jeux-evenements',
                eventLabel: 'recettes',
                event: 'genericGAEvent'
            });
        }
        let config = new RequestConfig();
        config.url = (this._form.querySelector('form')as HTMLFormElement).action;
        config.data = this._fV.serialize();
        config.headers ={'content-type' : 'application/x-www-form-urlencoded'};
        config.method = RequestMethod.POST;

        // Création (et envoi de la requête)
        let request = new Request(config);

        // Événements à écouter
        request.addListener(RequestEvent.LOAD, this._onLoad);   

    }

    @autobind
    private _onLoad(e) {
        var data = JSON.parse(e.response); // réponse de la requête
        if(data.success) {
            let txtOther = document.querySelector('[data-js="txtOther"]');
            let txtWinner = document.querySelector('[data-js="txtWinner"]')
            let txtLooser = document.querySelector('[data-js="txtLooser"]')

            if(data.has_contest) {
                if(data.is_winner) {
                    (txtWinner as HTMLElement).style.display = 'block';
                    (txtLooser as HTMLElement).style.display = 'none';
                    if (txtOther) (txtOther as HTMLElement).style.display = 'none';
                    this._btnThanks.innerText = "Yééé";
                } else {
                    (txtWinner as HTMLElement).style.display = 'none';
                    (txtLooser as HTMLElement).style.display = 'block';
                    if (txtOther) (txtOther as HTMLElement).style.display = 'none';
                    this._btnThanks.innerText = "Tant pis";
                }
            } else {
                (txtWinner as HTMLElement).style.display = 'none';
                (txtLooser as HTMLElement).style.display = 'none';
                if (txtOther) (txtOther as HTMLElement).style.display = 'block';
                this._btnThanks.innerText = "Merci";
            }
            this._showThanks();
        } else {
            this._errorTxt.innerText = data.error_message;
        }
    };

    private _showThanks() {
        this._loading.style.display = "none";

        dataLayer.push({
            URI: document.location.pathname + '/confirmation',
            event: 'virtualPageview'
            });
        
        this._showElement(this._form, false,true);
        this._showElement(this._thanks, true, false);

        TweenMax.delayedCall(this._delayRestart,() => {
            this._restart();   
        });
        var fields = this._form.querySelectorAll('input[type="email"],input[type="text"]');
        for (let i = 0; i  < fields.length; i++) {
            var element:HTMLInputElement = fields[i] as HTMLInputElement;
            element.blur();
        }
    };

    @autobind
    private _restart(e = new Event('click')) {
        e.preventDefault();
        //Without reload and smooth animation transition
        
        // TweenMax.killAll();

        // this._fV.clear();

        // var fields = this._form.querySelectorAll('input[type="email"],input[type="text"]');
        // for (let i = 0; i  < fields.length; i++) {
        //     var element:HTMLInputElement = fields[i] as HTMLInputElement;
        //     element.blur();
        //     element.setAttribute('value', "");
        // }
        
        // if(e.currentTarget === this._btnCancel) {
        //     this._showElement(this._form, false,false);
        //     this._showElement(this._intro, true, true);
        // } else {
        //     this._showElement(this._thanks, false,false);
        //     this._showElement(this._intro, true, true);
        // }

        window.location.reload();
       
    }

    private _showElement(target:HTMLElement, animIn:boolean, left:boolean) {
        
        var dir:string = (left) ? "-200%" : "200%" ;

        TweenMax.set(target, {left:"50%"});
        
        if (animIn) {
            target.style.display = 'block';
            TweenMax.from(target, .5, {left:dir, ease: Quad.easeOut});
        } else {
            TweenMax.to(target, .5, {left:dir, ease: Quad.easeOut, onComplete: () => {
                target.style.display = 'none';
            }});
        }
        
        this.scrollTo(0);
    }
    
    private scrollTo(val) {
        TweenMax.to(['.main', 'body'], 0.5, {scrollTo: { y: val, autokill: false}});

    }

    
}
